import PropTypes from 'prop-types';
import { cx } from 'ramda-extension';

const CustomSVGIcon = ({ className, children, width = 20, height = 20, vbWidth, vbHeight, ...other }) => {
	return (
		<svg
			className={cx('SvgIcon', className)}
			{...other}
			width={`${width}px`}
			height={`${height}px`}
			viewBox={`0 0 ${vbWidth || width} ${vbHeight || height}`}
		>
			{children}
		</svg>
	);
};

CustomSVGIcon.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	height: PropTypes.number,
	vbHeight: PropTypes.number,
	vbWidth: PropTypes.number,
	width: PropTypes.number,
};

export default CustomSVGIcon;
